// ** MUI Imports
import Box from '@mui/material/Box'
import MuiAvatar from '@mui/material/Avatar'

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'
// ** Next Import
import Link from 'next/link'

// ** Components
//import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
//import UserDropdown from 'src/layouts/components/UserDropdown'
/*import Autocomplete from 'src/layouts/components/Autocomplete'*/
import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import LanguageDropdown from 'src/@core/layouts/components/shared-components/LanguageDropdown'
import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
import { styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
// ** Theme Config Import
import themeConfig from 'src/configs/themeConfig'
import CustomAvatar from 'src/@core/components/mui/avatar'
import AppUser from '../../../models/AppUser'

interface Props {
    settings: Settings
    saveSettings: (values: Settings) => void,
    user: AppUser,
    userAuthenticated : boolean
}

const AppBarContent = (props: Props) => {
    // ** Props
    const { settings, saveSettings, user, userAuthenticated } = props
    // ** Hooks
    const theme = useTheme()

    const StyledLink = styled('a')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        marginRight: theme.spacing(8)
    }))

    return (
        <>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <Typography variant='h5' sx={{ ml: 2, fontWeight: 500, lineHeight: 1.2 }}>
                    SocialOneApp
                </Typography>
            </Box>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <ModeToggler settings={settings} saveSettings={saveSettings} />
                <NotificationDropdown settings={settings} />
                {/*                    <MuiAvatar>H</MuiAvatar>*/}
                <Typography sx={{ mr: 2, fontWeight: 700, lineHeight: 1.2 }} >{user.name.split('@')[0]}</Typography>
{/*                <CustomAvatar>{(user.FirstName && user.LastName) ? user.FirstName.charAt(0) + user.LastName.charAt(0) : user.name.charAt(0) }</CustomAvatar>*/}
                <UserDropdown settings={settings} user={user} userAuthenticated={userAuthenticated} compactView />
            </Box>
        </>
    )
}

export default AppBarContent
